import { render, staticRenderFns } from "./suchen_zuordnen.vue?vue&type=template&id=1e5afb10&scoped=true"
import script from "./suchen_zuordnen.vue?vue&type=script&lang=js"
export * from "./suchen_zuordnen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e5afb10",
  null
  
)

export default component.exports